/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acceptedpersonname2Inputs */



/**

* @param {_Field_Acceptedpersonname2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acceptedpersonname2 = /** @type {((inputs?: _Field_Acceptedpersonname2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acceptedpersonname2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Akzeptiert von")
});
export { _field_acceptedpersonname2 as "_field_acceptedPersonName" }